import React, { useState, useRef, useEffect } from 'react';
import './RelajacionScreen.css';

// Simulación de datos: audios y sets de imágenes
const audios = [
  { file: '/relax1.mp3', label: 'Relajación 1', images: ['/relajacion/1-1.jpg', '/relajacion/1-2.jpg', '/relajacion/1-3.jpg'] },
  { file: '/relax2.mp3', label: 'Relajación 2', images: ['/relajacion/2-1.jpg', '/relajacion/2-2.jpg', '/relajacion/2-3.jpg'] },
  { file: '/relax3.mp3', label: 'Relajación 3', images: ['/relajacion/3-1.jpg', '/relajacion/3-2.jpg', '/relajacion/3-3.jpg'] },
  { file: '/relax4.mp3', label: 'Relajación 4', images: ['/relajacion/4-1.jpg', '/relajacion/4-2.jpg', '/relajacion/4-3.jpg'] },
];


export default function RelajacionScreen({ onBack, onComenzarTratamiento }) {
  const [audioIdx, setAudioIdx] = useState(0);
  const [imgIdx, setImgIdx] = useState(0);
  const intervalRef = useRef();

  // Cambia el slideshow cada 10 segundos y reinicia automáticamente
  useEffect(() => {
    clearInterval(intervalRef.current);
    setImgIdx(0);
    intervalRef.current = setInterval(() => {
      setImgIdx(idx => {
        const next = idx + 1;
        return next >= audios[audioIdx].images.length ? 0 : next;
      });
    }, 10000);
    return () => clearInterval(intervalRef.current);
  }, [audioIdx]);

  // Cambia a la primera imagen si cambias de audio
  useEffect(() => {
    setImgIdx(0);
  }, [audioIdx]);

  return (
    <div className="relajacion-fullscreen">
      <div className="relajacion-slideshow-full">
        <img
          src={audios[audioIdx].images[imgIdx]}
          alt={`Imagen ${imgIdx + 1}`}
          className="relajacion-img-full"
        />
        <div className="relajacion-audio-box-full">
          <audio controls autoPlay key={audios[audioIdx].file} className="relajacion-audio-transp">
            <source src={audios[audioIdx].file} type="audio/mpeg" />
            Tu navegador no soporta audio HTML5.
          </audio>
        </div>
        <div className="relajacion-audio-selector-full">
          {audios.map((a, i) => (
            <button
              key={a.file}
              className={i === audioIdx ? 'relajacion-audio-btn active' : 'relajacion-audio-btn'}
              onClick={() => setAudioIdx(i)}
            >
              {a.label}
            </button>
          ))}
        </div>
        <button className="relajacion-back-full" onClick={onBack}>← Volver</button>
      </div>
    </div>
  );
}
